import { AnalysisService } from '../services/analysis.service';
import { Component, ViewChild, NgModule, VERSION, OnInit, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser'
import { NguiMapComponent, DrawingManager, NguiMap, Marker } from '@ngui/map';
import { Observable } from 'rxjs/Observable';
import { MatSlider } from '@angular/material';
import { RoofModel } from '../model/roof.model';
import { RecommendationService } from 'app/services/recommendation.service';
import { PanelsService } from 'app/services/panels.service';
import { WojewodztwaService } from 'app/services/wojewodztwa.service';
import { GeoCoder } from '@ngui/map/dist/services/geo-coder';
import { InstallationcostService } from 'app/services/installationcost.service';
import { isHK } from 'app/app.component';
// import { Marker } from '@ngui/map/dist/directives/marker';

declare var google: any;

const windRose = {
  180: 'Pd', // 'S',
  157.5: 'Pd Pd Wsch', //  'SSE',
  135: 'Pd Wsch', // 'SE',
  112.5: 'Wsch Pd Wsch', // 'ESE',
  90: 'Wsch', // 'E',
  67.5: 'Wsch Pn Wsch', // 'ENE',
  45: 'Pn Wsch', // 'NE',
  22.5: 'Pn Pn Wsch', // 'NNE',
  0: 'Pn', // 'N',
  360: 'Pn', // 'NNW',
  337.5: 'Pn Pn Zach', // 'NNW',
  315: 'Pn Zach', // 'NW',
  292.5: 'Zach Pn Zach', // 'WNW',
  270: 'Zach', // 'W',
  247.5: 'Zach Pd Zach', // 'WSW',
  225: 'Pd Zach', // 'SW',
  202.5: 'Pd Pd Zach', // 'SSW'
};

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  centerOfMap: any;
  drawingControl = true;
  zoom = 18;
  mapTypeId = 'satellite';
  streetViewControl = false;
  mapTypeControl = false;
  gfb = [52.234238, 21.056016];
  fullscreenControl = true;

  defFillOpacity = 0.6;

  polygonOptions = {
    clickable: true,
    draggable: true,
    editable: false,
    fillColor: '#ffff00',
    fillOpacity: this.defFillOpacity,
    strokeColor: '#ffff00',
    strokeWeight: 2,
    visible: true,
    zIndex: 1
  };

  @ViewChild(DrawingManager) drawingManager: DrawingManager;
  @ViewChild(MatSlider) matSlider: MatSlider;
  @ViewChild(NguiMapComponent) theMap: NguiMapComponent;

  address: any;
  width: number;
  height: number;
  length: number;

  thumbLabel = true;
  angle_h = 180;
  angle_v = 35;


  polygonNum: number;
  currentRoof: RoofModel;


  constructor(
    private installationcostService: InstallationcostService,
    private ref: ChangeDetectorRef,
    private ngZone: NgZone,
    private analysisService: AnalysisService,
    private recommendationService: RecommendationService,
    private panelsService: PanelsService,
    private wojService: WojewodztwaService) { }


  ngOnInit() {
    this.polygonNum = 0;

    this.drawingManager['initialized$'].subscribe(dm => {
      google.maps.event.addListener(dm, event => {
        console.log('Event: ', event);
      });
      google.maps.event.addListener(dm, 'overlaycomplete', event => { // overlaycomplete
        if (event.type === google.maps.drawing.OverlayType.MARKER) {
          // console.log('Marker: ', event);
          let marker: google.maps.Marker;
          marker = event.overlay;
          marker.setOpacity(0.5);
          marker.setDraggable(true);

          marker.addListener('click', m => marker.setMap(null));
          marker.setMap(null);
          const pp = marker.getPosition();
          const dach = this.analysisService.allPolygons.find(r => google.maps.geometry.poly.containsLocation(pp, r.overlay));
          if (dach) {
            dach.setArrowPoints(pp, this.theMap.map);
          }
        } else
          if (event.type === google.maps.drawing.OverlayType.POLYGON) {
            this.polygonNum += 1;
            const r = new RoofModel(event.overlay, this.angle_v, this.angle_h, windRose[this.angle_h]);
            this.analysisService.allPolygons.push(r);
            this.currentRoof = r;
            this.roofChanged(r);

            google.maps.event.addListener(event.overlay, 'mouseup', e => {
              if (e.vertex !== undefined || e.edge !== undefined) {
                return;
              }
              this.updateCurrent(event.overlay);
              event.overlay.setEditable(true);
            });

            google.maps.event.addListener(event.overlay, 'mouseout', e => {
              this.updateCurrent(event.overlay);
            });

            google.maps.event.addListener(event.overlay.getPath(), 'set_at', e => {
              this.updateCurrent(event.overlay);
            });

            google.maps.event.addListener(event.overlay.getPath(), 'insert_at', e => {
              this.updateCurrent(event.overlay);
            });
          }
      });
    });
  }

  getIsHK(): boolean {
    return isHK;
  }

  updateCurrent(roofOverlay: any) {
    const rf = this.findRoof(roofOverlay);
    this.currentRoof = rf;
    this.roofChanged(rf);
  }


  findRoof(roof: any): RoofModel {
    const rm = this.analysisService.allPolygons.find(r =>
      roof.latLngs === r.overlay.latLngs
    );
    return rm;
  }

  roofChanged(rf: RoofModel) {
    if (this.roofExist()) {
      this.currentRoof.updateRoof(this.analysisService);
      this.recommendationService.updReccomendations();
      this.installationcostService.updateCosts();
      this.analysisService.allPolygons.sort((a: RoofModel, b: RoofModel) => b.powerMax - a.powerMax);
      // this.analysisService.currentRoof = this.analysisService.allPolygons[0];
      this.updateOpacity();
    };
  }

  roofExist() {
    return this.analysisService.allPolygons.length > 0;
  }

  roofLocationOk(): boolean {
    // znajdź dach
    let result = false;
    if (this.analysisService.allPolygons.length > 0) {
      const loc = this.analysisService.getDachLocation()
      const llat = loc.lat();
      const llng = loc.lng();
      result = this.wojService.checkLocation(llat, llng);
    }
    return result;
  }

  updateOpacity() {
    this.analysisService.allPolygons.forEach((element, index) => {
      if (index === 0) {
        this.polygonOptions.fillOpacity = this.defFillOpacity;
        this.polygonOptions.fillColor = '#ff0f0f';
      } else {
        this.polygonOptions.fillOpacity = this.defFillOpacity;
        this.polygonOptions.fillColor = '#ffff00';
      }
      this.polygonOptions.editable = false;
      element.overlay.setOptions(this.polygonOptions);
      element.overlay.setEditable(false);
    });
  }

  onOrientationChange() {
    this.currentRoof.angleHLabel = windRose[this.currentRoof.angleH];
    this.roofChanged(this.currentRoof);
    this.recommendationService.calc20YSavings();
  };

  onAngleChange() {
    this.roofChanged(this.currentRoof);
    this.recommendationService.calc20YSavings();
  };

  deleteSelectedOverlay() {
    if (this.roofExist()) {
      const idx = this.analysisService.allPolygons
        .findIndex(poly => this.currentRoof.overlay.latLngs === poly.overlay.latLngs);
      if (idx !== -1) {
        this.analysisService.allPolygons.splice(idx, 1);
      }
      this.currentRoof.overlay.setMap(null);
      this.currentRoof.deleteArrow();
      delete this.currentRoof;
      this.polygonNum--;
      if (this.polygonNum > 0) {
        this.currentRoof = this.analysisService.allPolygons[0];
        this.roofChanged(this.currentRoof);
      }
    }
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/map/map.component.ts